import React from "react";
import Banner from "../components/allbanner";
import chartImage from "../images/chart2.png"; // replace with actual import path
import warehouse1 from "../images/warehouse1.jpg"; // replace with actual
import warehouse2 from "../images/warehouse2.jpg";
import staff from "../images/staff.jpg";
import {
  MessageCircle
} from "lucide-react";

// === Animations ===
const styles = `
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { opacity: 0; animation: fadeInUp 1s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }
`;

const PartsDepartment = () => {
  return (
    <div className="bg-gradient-to-b from-gray-50 via-white to-gray-100">
      <style>{styles}</style>

      {/* Banner */}
      <Banner
        title="Parts Department"
        description="Reliable, authentic, and customer-focused — the backbone of Isuzu Gujranwala operations."
      />

      <div className="container mx-auto px-6 mt-16">
        {/* Mission Section */}
        <section className="text-center max-w-3xl mx-auto mb-16 animate-fadeInUp delay-100">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4 border-l-4 border-[#D71920] pl-3 inline-block">
            Our Mission
          </h2>
          <p className="text-gray-700 leading-relaxed text-lg">
            Our mission is to provide reliable, high-quality parts and exceptional service
            to support the operational needs of our customers. We are committed to ensuring
            availability, efficiency, and cost-effectiveness by maintaining a well-stocked
            inventory, delivering timely solutions, and fostering long-term partnerships.
            Through innovation, professionalism, and teamwork, we aim to exceed expectations
            and contribute to the overall success of our organization.
          </p>
        </section>

        {/* Authenticity & Professionalism Section */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-20 items-center animate-fadeInUp delay-200">
          <div>
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              Authenticity & Professional Expertise
            </h3>
            <p className="text-gray-600 mb-4">
              At Isuzu Gujranwala Motors, authenticity and trust form the foundation of our parts
              department. Every component we supply is 100% genuine and sourced directly from
              authorized Isuzu channels — ensuring durability and unmatched reliability.
            </p>
            <p className="text-gray-600 mb-6">
              Our staff is professionally trained by Isuzu and equipped with the technical
              expertise to guide customers accurately, ensuring they receive the right part
              every time. From engine components to body fittings, our team ensures precision,
              quality, and satisfaction in every transaction.
            </p>
            <a
              href="/contact"
              className="bg-[#D71920] text-white px-8 py-3 rounded-md hover:bg-[#b81419] transition-all duration-300 shadow-md hover:shadow-lg"
            >
              Contact Our Parts Team
            </a>
          </div>

          <div className="relative rounded-xl overflow-hidden shadow-xl">
            <img
              src={staff}
              alt="Staff working"
              className="object-cover w-full h-80 transform hover:scale-110 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-black/30"></div>
          </div>
        </section>

        {/* Warehouse Images */}
        <section className="mb-20 animate-fadeInUp delay-200">
          <h3 className="text-2xl font-semibold text-gray-900 mb-8 text-center">
            Our Well-Stocked Warehouses
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[warehouse1, warehouse2].map((img, i) => (
              <div
                key={i}
                className="relative rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-transform hover:-translate-y-1 duration-500"
              >
                <img
                  src={img}
                  alt={`Warehouse ${i + 1}`}
                  className="object-cover w-full h-72"
                />
                <div className="absolute inset-0 bg-black/20"></div>
              </div>
            ))}
          </div>
        </section>

        {/* Organizational Chart */}
        <section className="text-center animate-fadeInUp delay-300">
          <h3 className="text-2xl font-semibold text-gray-900 mb-6">
            Our Department Structure
          </h3>
          <div className="flex justify-center">
            <img
              src={chartImage}
              alt="Parts Department Chart"
              className="max-w-full md:max-w-3xl shadow-lg rounded-lg border border-gray-200"
            />
          </div>
        </section>

        {/* CTA */}


      </div>
      <section className="relative mt-20 py-20 px-6 text-center bg-gradient-to-r from-[#D71920] to-[#A50E0E] text-white animate-fadeInUp delay-300">
        <h3 className="text-3xl sm:text-4xl font-extrabold mb-4">
          We Keep Your Isuzu Moving
        </h3>
        <p className="text-gray-100 mb-10 max-w-xl mx-auto leading-relaxed">
          Whether you need engine parts, accessories, or expert guidance — our team is dedicated to providing timely, authentic, and efficient solutions.
        </p>

        {/* Buttons Row */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          {/* Contact Button */}
          <a
            href="/contact"
            className="bg-white text-[#D71920] font-bold px-8 py-3 rounded-xl shadow-lg hover:bg-gray-100 transition-all inline-flex items-center gap-2"
          >
            Get in Touch
          </a>

          {/* WhatsApp Button */}
          <a
            href={`https://wa.me/923129388531?text=${encodeURIComponent(
              "Hello! I’d like to get assistance regarding Isuzu parts or service."
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-semibold px-8 py-3 rounded-xl shadow-lg transition-all inline-flex items-center gap-2"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp Us
          </a>
        </div>
      </section>
    </div>

  );
};

export default PartsDepartment;
